// 动态修改自动定义颜色
export const setCssVar = (prop, val, dom = document.documentElement) => {
    dom.style.setProperty(prop, val)
  }